import { useMemo } from "react";
import GatheringAccessEnum from "src/api/graphql/__generated__/enums/GatheringAccessEnum";
import PhotoState from "src/api/graphql/__generated__/enums/PhotoState";
import Menu from "src/components/Menu";
import { useGatheringStore } from "src/contexts/GatheringContext";
import { getClientId, useClientId } from "src/helpers/globalHelpers";
import useDevice from "src/hooks/useDevice";
import IconEllipsis from "src/icons/IconEllipsis";
import { Pill } from "src/swsh-native";
import usePhotoOptionsActions from "../hooks/usePhotoOptionsActions";
import usePhotoDetailStore from "../stores/usePhotoDetailStore";

const PhotoOptions = () => {
	const { device } = useDevice();
	const photoOwnerId = usePhotoDetailStore((store) => store.curPhoto?.ownerId);
	const isHidden = usePhotoDetailStore((store) => store.curPhoto?.state === PhotoState.Hidden);
	const clientId = useClientId();
	const isDepictedInPhoto = usePhotoDetailStore<boolean>(
		(store) => store.asyncSettledPhoto?.tags?.some((tag) => tag.userId === clientId) ?? false,
	);

	const isOwner = useMemo(() => photoOwnerId && photoOwnerId === getClientId(), [photoOwnerId]);
	const access = useGatheringStore((state) => state.access);
	const isAdmin = access === GatheringAccessEnum.Admin;

	const {
		handleDelete,
		handleHide,
		handleUnhide,
		handleHidePhotoDepictedIn,
		handleNotMe,
		handleReport,
	} = usePhotoOptionsActions();

	return (
		<Menu.Root>
			<Menu.Trigger>
				<Pill Icon={IconEllipsis} opaque={device === "mobile"} />
			</Menu.Trigger>
			<Menu.Content>
				{isAdmin && !isHidden && (
					<Menu.Item key="hide" onSelect={handleHide}>
						<Menu.ItemTitle>Hide</Menu.ItemTitle>
					</Menu.Item>
				)}
				{isAdmin && isHidden && (
					<Menu.Item key="unhide" onSelect={handleUnhide}>
						<Menu.ItemTitle>Unhide</Menu.ItemTitle>
					</Menu.Item>
				)}
				{isDepictedInPhoto && (
					<Menu.Item key="notMe" onSelect={handleNotMe}>
						<Menu.ItemTitle>This isn't me</Menu.ItemTitle>
					</Menu.Item>
				)}
				{!isAdmin && isDepictedInPhoto && (
					<Menu.Item key="hideDepicted" onSelect={handleHidePhotoDepictedIn}>
						<Menu.ItemTitle>Hide photo</Menu.ItemTitle>
					</Menu.Item>
				)}
				{isOwner ? (
					<Menu.Item key="delete" onSelect={handleDelete} destructive>
						<Menu.ItemTitle>Delete</Menu.ItemTitle>
					</Menu.Item>
				) : (
					<Menu.Item key="report" onSelect={handleReport} destructive>
						<Menu.ItemTitle>Report</Menu.ItemTitle>
					</Menu.Item>
				)}
			</Menu.Content>
		</Menu.Root>
	);
};
export default PhotoOptions;
